import { useMutation } from '@tanstack/react-query';
import { releaseTimeSlot } from '@services/cpqService';

type UseReleaseSlotOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useReleaseSlot = ({ onSuccess, onError }: UseReleaseSlotOptions = {}) => {
  const mutation = useMutation<void, Error, number>({
    mutationFn: (shoppingCartId) => releaseTimeSlot(shoppingCartId),
    onSuccess,
    onError,
  });

  return {
    release: mutation.mutate,
    releaseAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
